
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"16","viewBox":"0 0 46 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.574 7.517h36.32","stroke":"#000","stroke-width":"1.583","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M0 7.517c4.51 1.662 10.05 4.51 13.53 7.517l-2.69-7.517L13.53 0C10.05 3.007 4.51 5.855 0 7.517z","fill":"#000"}})])
          )
        }
      }
    